import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 全局组测
import './utils/global.js';
// 全局样式（3.0主题）
import './assets/styles/global.less';
import './assets/styles/responsive.less';
import Cookies from 'js-cookie'
Vue.prototype.$cookies = Cookies;
// iconify-icon 是 Web Component，避免 Vue2 报 Unknown custom element
Vue.config.ignoredElements = ['iconify-icon']
Vue.config.productionTip = false

// 刷新页面后从 cookie 恢复登录态，避免 Vuex 丢失导致 header 显示为未登录
import { getToken } from '@/localCache/cookie';
import { getCurrentUser } from '@/api/home/home.js';
const token = getToken();
if (token) {
  store.commit('SET_TOKEN', token);
  // 异步恢复用户信息，不阻塞渲染
  getCurrentUser().then(user => {
    store.dispatch('setCurrentUser', user?.model || null);
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
